import DOMPurify from 'dompurify';
import { useFormatDateTime } from 'hooks/useFormatDateTime';
import { Col, Modal, Row } from 'react-bootstrap';

/**
 * Formats images in HTML content to ensure they don't exceed the container width
 * @param {string} html - The HTML content to process
 * @returns {string} - The formatted HTML with image size constraints
 */
const formatImagesInDescription = html => {
  if (!html) return '';

  // Create a temporary DOM element to parse the HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  // Find all images and apply max-width styling
  const images = tempDiv.querySelectorAll('img');
  images.forEach(img => {
    // Set max-width to 100% and height to auto to maintain aspect ratio
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.display = 'block';
    img.style.marginTop = '0.5rem';
    img.style.marginBottom = '0.5rem';
  });

  return tempDiv.innerHTML;
};

const formatTime = time => {
  if (!time) return '';
  return time.substring(0, 5);
};

const TicketAppointmentViewModal = ({ data, showModal, handleClose }) => {
  const formatDateTime = useFormatDateTime();
  const sanitizedHtml = DOMPurify.sanitize(data.description);
  const formattedHtml = formatImagesInDescription(sanitizedHtml);
  return (
    <Modal size="lg" show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Visualizar apontamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col md={3}>
            <h6>Dia</h6>
            <p>{formatDateTime(data.date)}</p>
          </Col>
          <Col md={3}>
            <h6>Início</h6>
            <p>{formatTime(data.startTime)}</p>
          </Col>
          <Col md={3}>
            <h6>Fim</h6>
            <p>{formatTime(data.endTime)}</p>
          </Col>
          <Col md={3}>
            <h6>Tempo Gasto</h6>
            <p>{formatTime(data.timeSpent)}</p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={4}>
            <h6>Tipo de serviço</h6>
            <p>{data.typeService?.description || 'Não informado'}</p>
          </Col>
          <Col md={4}>
            <h6>Tipo de apontamento</h6>
            <p>{data.reasonDescription || data.typeService?.description}</p>
          </Col>
          <Col md={4}>
            <h6>SLA Regularizado</h6>
            <p>{data.slaEligible ? 'Sim' : 'Não'}</p>
          </Col>
        </Row>

        {data.backdateReason && (
          <Row className="mb-3">
            <Col md={12}>
              <h6>Motivo Retroativo</h6>
              <p>{data.backdateReason}</p>
            </Col>
          </Row>
        )}

        <Row>
          <Col md={12}>
            <h6>Descrição</h6>
            <div
              className="w-100 overflow-x-hidden"
              dangerouslySetInnerHTML={{ __html: formattedHtml }}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default TicketAppointmentViewModal;
